import { createSelector } from 'reselect';

const historySelector = state => state.history;

export const historyDataSelector = createSelector(
  historySelector,
  history => history.historyData,
);

export const isFetchingHistorySelector = createSelector(
  historySelector,
  history => history.isFetchingHistory,
);

export const isCancelSucceedSelector = createSelector(
  historySelector,
  history => history.isCancelSucceed,
);
export const cancelReasonsSelector = createSelector(
  historySelector,
  history => history.cancelReasons,
);
